import { useEffect, useState } from 'react';
import api from '../utils/api';

// Which accounting and payroll integrations this organisation has connected. A section shows an
// integration's tab (Invoices › Xero, Timesheets › Employment Hero payroll…) only when it is
// connected; connecting and disconnecting happen in Settings › Integrations.
// Read once per page visit; a failed check counts as not connected.
export default function useConnectedIntegrations() {
  const [state, setState] = useState({ loaded: false, xero: false, employmentHero: false, quickbooks: false });
  useEffect(() => {
    let live = true;
    const ok = (p) => p.then((r) => !!r.data?.connected).catch(() => false);
    Promise.all([ok(api.get('/xero-sync/status')), ok(api.get('/integrations/employment-hero/status')), ok(api.get('/qb-sync/status'))])
      .then(([xero, employmentHero, quickbooks]) => { if (live) setState({ loaded: true, xero, employmentHero, quickbooks }); });
    return () => { live = false; };
  }, []);
  return state;
}
